const months = [
  { abbreviated: 'Jan', full: 'January' },
  { abbreviated: 'Feb', full: 'February' },
  { abbreviated: 'Mar', full: 'March' },
  { abbreviated: 'Apr', full: 'April' },
  { abbreviated: 'May', full: 'May' },
  { abbreviated: 'Jun', full: 'June' },
  { abbreviated: 'Jul', full: 'July' },
  { abbreviated: 'Aug', full: 'August' },
  { abbreviated: 'Sep', full: 'September' },
  { abbreviated: 'Oct', full: 'October' },
  { abbreviated: 'Nov', full: 'November' },
  { abbreviated: 'Dec', full: 'December' },
];

const weekdays = [
  { abbreviated: 'Sun', full: 'Sunday' },
  { abbreviated: 'Mon', full: 'Monday' },
  { abbreviated: 'Tue', full: 'Tuesday' },
  { abbreviated: 'Wed', full: 'Wednesday' },
  { abbreviated: 'Thu', full: 'Thursday' },
  { abbreviated: 'Fri', full: 'Friday' },
  { abbreviated: 'Sat', full: 'Saturday' },
];

export default {
  months,
  weekdays,
};
